/**
 * Google Tag Manager utility functions for Redwood app
 */

declare global {
  interface Window {
    dataLayer?: any[]
  }
}

interface GTMPageViewEvent {
  event: string
  event_id: string
  page_path: string
  page_location: string
  page_title: string
}

interface GTMCustomEvent {
  event: string
  [key: string]: any
}

/**
 * Push a page view event to GTM dataLayer
 */
export const trackPageView = (
  pagePath: string,
  pageLocation: string,
  pageTitle: string
): void => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    return
  }

  const eventId = `${Date.now()}_${Math.random().toString(36).substring(2, 11)}`

  const event: GTMPageViewEvent = {
    event: 'virtual_page_view',
    event_id: eventId,
    page_path: pagePath,
    page_location: pageLocation,
    page_title: pageTitle,
  }

  window.dataLayer.push(event)
}

/**
 * Push a custom event to GTM dataLayer
 */
export const trackCustomEvent = (eventData: GTMCustomEvent): void => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    return
  }

  window.dataLayer.push(eventData)
}
